import React from 'react';
import PropTypes from 'prop-types';

import style from './BackgroundPlayer.scss';

/**
 * Basic wrapper around a html video that display video in the background
 */
const BackgroundPlayer = (props) => {
	const {
		backgroundVideo,
		backgroundImage,
	} = props;

	if (backgroundVideo && backgroundVideo.url) {
		return (
			/* eslint-disable-next-line jsx-a11y/media-has-caption */
			<video muted className={style.player} loop={backgroundVideo.loop} autoPlay={backgroundVideo.autoplay} src={backgroundVideo.url} />
		);
	}

	if (backgroundImage && backgroundImage.url) {
		/* eslint-disable-next-line jsx-a11y/media-has-caption */
		return <img className={style.player} alt="background decoration" src={backgroundImage.url} />;
	}

	return null;
};

BackgroundPlayer.propTypes = {
	backgroundImage: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	backgroundVideo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default BackgroundPlayer;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/resultsvisualization/childcomponents/BackgroundPlayer.component.js